<template>
  <div class="allIssue">
    <zdy-nav title="全部问题" @back="back" :showClose="true" @close="close"></zdy-nav>
    <div class="issue-content">
      <cube-scroll
        :data="issueList"
        ref="cubeScroll"
      >
        <div
          class="issueBar"
          v-for="(item, index) in issueList"
          :key="index"
        >
          <div class="title" @click="showHide(item)">
            <div class="blue-line"></div>
            {{ item.typeName }}
            <div class="more" :class="{ Rotation: item.isShow }"><i class="cubeic-select"></i></div>
          </div>
          <div class="container" v-show="item.isShow">
            <ul>
              <li
                v-for="(item, index) in item.questionList"
                :key="index"
                @click="toDetails(item)"
              >
                {{ index + 1 }}、{{ item.questionName }}
              </li>
            </ul>
            <div
              v-if="item.questionList.length === 0"
              style="text-align: center;"
            >
              暂无数据
            </div>
          </div>
        </div>
      </cube-scroll>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      issueList: [],
    }
  },
  created() {
    this.getAllIssueList();
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    close() {
      this.$cjc.closeWebView();
    },
    toDetails(item) {
      if (item.answerType === 1) {
        this.$router.push({ name: 'answerPage', params: item });
      } else {
        window.open(item.answer);
      }
    },
    getAllIssueList() {
      this.$store.dispatch('getQuestionListByType')
        .then((res) => {
          if (res.data.status === 1000) {
            const { result } = res.data;
            this.issueList = result.map((item) => {
              item.isShow = false;
              return item;
            });
          }
        })
    },
    showHide(item) {
      item.isShow = !item.isShow;
    }
  }
}
</script>

<style lang="scss">
.allIssue {
  .issue-content {
    background-color: #F6F6F6;
    margin-top: 50px;
    height: calc(100vh - 50px);
    overflow-y: auto;
    .issueBar {
      width: calc(100% - 50px);
      background: #ffffff;
      margin: 10px;
      border-radius: 5px;
      padding: 0 15px;
      .title {
        padding: 10px 0;
        font-size: 15px;
        font-weight: bold;
        .blue-line {
          margin-right: 5px;
          vertical-align: baseline;
          display: inline-block;
          width: 3px;
          height: 12px;
          border-radius: 10px;
          background-color: #3296FA;
        }
        .more {
          transition: transform .3s;
          font-size: 18px;
          float: right;
          color: #3296FA;
        }
        .Rotation {
          transform: rotate(180deg);
        }
      }
      .container {
        font-size: 12px;
        padding: 10px;
        ul {
          li {
            margin-bottom: 5px;
            padding: 0 5px 3px 5px;
            height: 25px;
            line-height: 25px;
            border-bottom: 1px solid #EFEFF4;
            overflow: hidden; 
            text-overflow: ellipsis; 
            white-space: nowrap;
          }
        }
      }
    }
  }
}
</style>